function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import BlocksDocument from './blocks-document';
import { BLOCK_TYPES, DEFAULT_ALIGNMENT, HORIZONTAL_RULE_FALLBACK, NO_MARGIN_CLASS } from './constants';
import { TextSerializer } from './serializer/text-serializer';
import Ember from 'ember';
export default class BlocksSerializer {
  constructor(config, schema) {
    _defineProperty(this, "config", void 0);
    _defineProperty(this, "schema", void 0);
    this.config = config;
    this.schema = schema;
  }
  serialize(doc) {
    if (doc.type.name !== 'doc') {
      throw new Error('Must provide an entire document to serialize');
    }
    return this.serializeFragment(doc.content);
  }
  serializeSlice(slice) {
    return this.serializeFragment(slice.content);
  }
  serializeFragment(fragment) {
    let blockList = [];
    fragment.forEach(node => {
      let serialized = this.serializeBlock(node);
      if (serialized) {
        blockList.push(serialized);
      }
    });
    return new BlocksDocument(blockList);
  }
  serializeBlock(node) {
    switch (node.attrs.type) {
      case BLOCK_TYPES.PARAGRAPH:
      case BLOCK_TYPES.HEADING:
      case BLOCK_TYPES.SUBHEADING:
      case BLOCK_TYPES.SUBHEADING3:
      case BLOCK_TYPES.SUBHEADING4:
      case BLOCK_TYPES.SMALL:
      case BLOCK_TYPES.CODE:
        return this.serializeTextBlock(node);
      case BLOCK_TYPES.IF_ELSE_STATEMENT:
        return this.serializeIfElseStatement(node);
      case BLOCK_TYPES.IMAGE:
        if (!this.isIncompleteUpload(node.attrs.src)) {
          return this.serializeAsImage(node);
        }
        return undefined;
      case BLOCK_TYPES.IMAGE_TEXT:
        return this.serializeAsImageText(node);
      case BLOCK_TYPES.ORDERED_LIST:
      case BLOCK_TYPES.UNORDERED_LIST:
        return this.serializeAsList(node);
      case BLOCK_TYPES.VIDEO:
        return this.serializeAsVideo(node);
      case BLOCK_TYPES.VIDEO_FILE:
        return this.serializeAsVideoFile(node);
      case BLOCK_TYPES.AUDIO_FILE:
        return this.serializeAsAudioFile(node);
      case BLOCK_TYPES.BUTTON:
        return this.serializeAsButton(node);
      case BLOCK_TYPES.HORIZONTAL_RULE:
        return this.serializeAsHorizontalRule(node);
      case BLOCK_TYPES.MESSENGER_CARD:
        return this.serializeAsMessengerCard(node);
      case BLOCK_TYPES.TABLE:
        return this.serializeAsTable(node);
      case BLOCK_TYPES.ORDERED_NESTED_LIST:
      case BLOCK_TYPES.UNORDERED_NESTED_LIST:
        return this.serializeAsNestedList(node);
      case BLOCK_TYPES.HTML:
        return this.serializeHtmlBlock(node);
      case BLOCK_TYPES.TWITTER_FOLLOW_BUTTON:
        return this.serializeTwitterFollowButton(node);
      case BLOCK_TYPES.FACEBOOK_LIKE_BUTTON:
        return this.serializeFacebookLikeButton(node);
      case BLOCK_TYPES.SOCIAL:
        return this.serializeAsSocial(node);
      case BLOCK_TYPES.SPACER:
        return this.serializeAsSpacer(node);
      case BLOCK_TYPES.CALLOUT:
        return this.serializeCallout(node);
      case BLOCK_TYPES.COLLAPSIBLE_SECTION:
        return this.serializeAsCollapsibleSection(node);
      case BLOCK_TYPES.UNSUPPORTED_ELEMENT:
        return this.serializeAsUnsupportedElement(node);
    }
    return undefined;
  }
  serializeTwitterFollowButton(node) {
    let button = {
      type: node.attrs.type,
      username: node.attrs.username
    };
    return button;
  }
  serializeFacebookLikeButton(node) {
    let button = {
      type: node.attrs.type,
      url: node.attrs.url
    };
    return button;
  }
  isHeadingBlock(node) {
    return node.type === 'heading' || node.type === 'subheading' || node.type === 'subheading3' || node.type === 'subheading4';
  }
  serializeTextBlock(node) {
    let p = {
      type: node.attrs.type,
      text: ''
    };
    this.addAlignment(p, node);
    this.addStyle(p, node);
    if (p.type === 'paragraph' && this.config.allowEmptyParagraphs) {
      p.allowEmpty = true;
    }
    if (p.type === 'paragraph' && !this.config.allowImplicitMarginParagraphs) {
      p.class = NO_MARGIN_CLASS;
    }
    p.text = new TextSerializer(this.schema, this.config).serializeNode(node);
    if (this.isHeadingBlock(p)) {
      p.idAttribute = node.attrs.idAttribute;
    }
    return p;
  }
  serializeHtmlBlock(node) {
    let html = {
      type: node.attrs.type,
      content: '',
      header: null,
      footer: null
    };
    html.content = node.attrs.content || '';
    return html;
  }
  serializeIfElseStatement(node) {
    let ifElseStatement = {
      type: node.attrs.type,
      fallbackBlocks: node.attrs.fallbackBlocks,
      predicatesBlocksPairs: node.attrs.predicatesBlocksPairs
    };
    return ifElseStatement;
  }
  serializeAsImage(node) {
    let img = {
      type: node.attrs.type,
      url: ''
    };
    this.addAlignment(img, node);
    img.url = node.attrs.src;
    if (node.attrs.linkUrl) {
      img.linkUrl = node.attrs.linkUrl;
    }
    if (node.attrs.width) {
      img.width = Number(node.attrs.width);
    }
    if (node.attrs.height) {
      img.height = Number(node.attrs.height);
    }
    if (node.attrs.displayWidth) {
      img.displayWidth = Number(node.attrs.displayWidth);
    }
    if (node.attrs.text) {
      img.text = node.attrs.text;
    }
    return img;
  }
  serializeAsImageText(node) {
    let imgText = {
      type: node.attrs.type,
      imageUrl: node.attrs?.imageUrl || '',
      title: node.attrs?.title,
      text: node.attrs?.text
    };
    return imgText;
  }
  serializeAsList(node) {
    let list = {
      type: node.attrs.type,
      items: []
    };
    this.addStyle(list, node);
    node.content.forEach(listItemNode => {
      list.items.push(new TextSerializer(this.schema).serializeNode(listItemNode.content.firstChild));
    });
    return list;
  }
  serializeAsNestedList(node) {
    let items = [];
    node.content.forEach(itemNode => {
      items.push(this.serializeAsNestedListItem(itemNode));
    });
    return {
      type: node.attrs.type,
      items
    };
  }
  serializeAsNestedListItem(node) {
    let content = [];
    node.content.forEach(blockNode => {
      let serialized = this.serializeBlock(blockNode);
      if (serialized) {
        content.push(serialized);
      }
    });
    return {
      content
    };
  }
  serializeAsVideo(node) {
    return {
      type: node.attrs.type,
      provider: node.attrs.provider,
      id: node.attrs.id
    };
  }
  serializeAsVideoFile(node) {
    return {
      type: node.attrs.type,
      thumbnailUrl: node.attrs.thumbnailUrl,
      url: node.attrs.url,
      captions: node.attrs.captions
    };
  }
  serializeAsAudioFile(node) {
    return {
      type: node.attrs.type,
      url: node.attrs.url
    };
  }
  serializeAsButton(node) {
    let handlebars = Ember.Handlebars;
    let escapedText = handlebars.Utils.escapeExpression(node.attrs.text);
    // We don't want to escape quotes as they are part of the syntax for template fallbacks.
    escapedText = escapedText.replaceAll('&quot;', '"');
    let button = {
      type: node.attrs.type,
      text: escapedText,
      linkUrl: node.attrs.linkUrl,
      buttonStyle: node.attrs.buttonStyle
    };
    this.addAlignment(button, node);
    this.addStyle(button, node);
    this.addPadding(button, node);
    return button;
  }
  serializeAsHorizontalRule(node) {
    let horizontalRule = {
      type: node.attrs.type,
      text: HORIZONTAL_RULE_FALLBACK
    };
    this.addNodeWidth(horizontalRule, node);
    this.addBorderStyles(horizontalRule, node);
    return horizontalRule;
  }
  serializeAsMessengerCard(node) {
    return {
      type: 'messengerCard',
      canvas: node.attrs.canvas,
      text: node.attrs.text,
      messenger_app_id: node.attrs.messenger_app_id,
      uri: node.attrs.uri
    };
  }
  serializeAsTable(node) {
    let rows = [];
    let container = node.attrs.container;
    let responsive = node.attrs.responsive;
    node.content.forEach(rowNode => {
      rows.push(this.serializeAsTableRow(rowNode, container));
    });
    let table = {
      type: node.attrs.type,
      responsive: node.attrs.responsive,
      container,
      rows
    };
    if (typeof node.attrs.stacked === 'boolean') {
      table.stacked = node.attrs.stacked;
    }
    if (container || responsive) {
      this.addStyle(table, node);
      this.addPadding(table, node);
    }
    if (node.attrs.sectionType) {
      table.sectionType = node.attrs.sectionType;
    }
    return table;
  }
  serializeAsTableRow(node, container) {
    let cells = [];
    node.content.forEach(cellNode => {
      cells.push(this.serializeAsTableCell(cellNode, container));
    });
    return {
      cells
    };
  }
  serializeAsTableCell(node, container) {
    let content = [];
    node.content.forEach(blockNode => {
      let serialized = this.serializeBlock(blockNode);
      if (serialized) {
        content.push(serialized);
      }
    });
    let tableCell = {
      content
    };
    if (container) {
      this.addPadding(tableCell, node);
    }
    if (!container && !node.attrs.responsive) {
      this.addBackgroundColor(tableCell, node);
    }
    if (node.attrs.colwidth?.length > 0) {
      tableCell.displayWidth = node.attrs.colwidth[0];
    }
    return tableCell;
  }
  serializeAsSocial(node) {
    let social = {
      type: node.attrs.type,
      items: node.attrs.items
    };
    this.addAlignment(social, node);
    return social;
  }
  serializeAsSpacer(node) {
    return {
      type: node.attrs.type,
      height: node.attrs.height
    };
  }
  serializeCallout(node) {
    let content = [];
    node.content.forEach(blockNode => {
      let serializedBlock = this.serializeBlock(blockNode);
      if (serializedBlock) {
        content.push(serializedBlock);
      }
    });
    return {
      type: node.attrs.type,
      content,
      style: {
        backgroundColor: node.attrs.backgroundColor,
        borderColor: node.attrs.borderColor
      }
    };
  }
  serializeAsUnsupportedElement(node) {
    return {
      type: node.attrs.type,
      unsupportedTypeName: node.attrs.unsupportedTypeName,
      text: node.attrs.text,
      category: 'unsupported'
    };
  }
  serializeAsCollapsibleSection(node) {
    let summary;
    let content = [];
    node.content.forEach(innerNode => {
      if (innerNode.attrs.type === BLOCK_TYPES.COLLAPSIBLE_SECTION_SUMMARY) {
        summary = this.serializeCollapsibleSectionSummary(innerNode);
      } else if (innerNode.attrs.type === BLOCK_TYPES.COLLAPSIBLE_SECTION_CONTENT) {
        content = this.serializeCollapsibleSectionContent(innerNode);
      }
    });
    return {
      type: node.attrs.type,
      summary: summary,
      content
    };
  }
  serializeCollapsibleSectionSummary(node) {
    let fallbackSummaryBlock = {
      type: 'paragraph',
      text: ''
    };
    let serializedBlock;
    if (node.content.firstChild) {
      serializedBlock = this.serializeBlock(node.content.firstChild);
    }
    if (serializedBlock) {
      return serializedBlock;
    }
    return fallbackSummaryBlock;
  }
  serializeCollapsibleSectionContent(node) {
    let contentBlocks = [];
    node.content.forEach(blockNode => {
      let serialized = this.serializeBlock(blockNode);
      if (serialized) {
        contentBlocks.push(serialized);
      }
    });
    return contentBlocks;
  }
  addAlignment(block, blockNode) {
    let alignment = blockNode.attrs.alignment;
    if (alignment && alignment !== DEFAULT_ALIGNMENT) {
      block.align = alignment;
    }
  }
  addNodeWidth(block, blockNode) {
    let width = blockNode.attrs.width;
    if (width) {
      block.width = width;
    }
  }
  addBackgroundColor(block, blockNode) {
    let backgroundColor = blockNode.attrs.backgroundColor;
    if (backgroundColor) {
      block.style = {
        ...block.style,
        backgroundColor
      };
    }
  }
  addBorderStyles(block, blockNode) {
    if (this.config.customStylesConfig?.allowCustomStyles) {
      let {
        borderColor,
        borderStyle,
        borderWidth
      } = blockNode.attrs;
      if (borderColor || borderStyle || borderWidth) {
        block.style = {
          ...block.style,
          ...(borderColor && {
            borderColor
          }),
          ...(borderStyle && {
            borderStyle
          }),
          ...(borderWidth && {
            borderWidth
          })
        };
      }
    }
  }
  addStyle(block, blockNode) {
    if (this.config.customStylesConfig?.allowCustomStyles) {
      let {
        fontFamily,
        fontColor,
        backgroundColor,
        borderRadius
      } = blockNode.attrs;
      if (fontFamily || fontColor || backgroundColor || borderRadius) {
        block.style = {
          ...block.style,
          ...(fontFamily && {
            fontFamily
          }),
          ...(fontColor && {
            fontColor
          }),
          ...(backgroundColor && {
            backgroundColor
          }),
          ...(borderRadius && {
            borderRadius
          })
        };
      }
    }
  }
  addPadding(block, blockNode) {
    if (this.config.customStylesConfig?.allowCustomStyles) {
      let {
        paddingTop,
        paddingBottom,
        paddingLeft,
        paddingRight
      } = blockNode.attrs;
      if (paddingTop || paddingBottom || paddingLeft || paddingRight) {
        block.style = {
          ...block.style,
          ...(paddingTop && {
            paddingTop
          }),
          ...(paddingBottom && {
            paddingBottom
          }),
          ...(paddingLeft && {
            paddingLeft
          }),
          ...(paddingRight && {
            paddingRight
          })
        };
      }
    }
  }
  isIncompleteUpload(url) {
    return url.startsWith('blob');
  }
}